import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { SecurityService } from '@core/services/security.service';
import { catchError, mergeMap } from 'rxjs/operators';

@Injectable()
export class VerifyInterceptor implements HttpInterceptor {
  constructor(private securitySvc: SecurityService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.headers.has('skip')) {
      return next.handle(req);
    }

    return this.securitySvc.getTokenObs().pipe(
      mergeMap((token: any) => {
        if (this.securitySvc.containsTempVersion()) {
          let tokenParts: string[] = token.split('|');
          token = `${tokenParts[0]}|${tokenParts[1]}|0}`;
        }
        if (token) {
          req = req.clone({
            setHeaders: { Authorization: token, Access: token },
          });
        }
        return next.handle(req);
      }),
      catchError((error: HttpErrorResponse) => throwError(error))
    );
  }
}
